export function getItemBySubstring(substring) {
  const values = [];
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (key.includes(substring)) {
      values.push(localStorage.getItem(key));
    }
  }
  return values;
}

export function formatDate(dateString) {
  if (dateString?.includes("/")) {
    const date = new Date(dateString.replace("/", "-"));
    console.log(`dateee //: ${JSON.stringify(date)}`);
  }
  const date = new Date(dateString);
  console.log(`dateee: ${JSON.stringify(date)}`);
  if (!isNaN(date)) {
    return date.toISOString().substring(0, 10);
  }
}

export function limitCharacter(element, limit = 10) {
  if (element?.length > limit) return `${element?.substring(0, 10)}...`;
  else return element;
}

export function convertToISODate(string) {
  const dateString = string;
  const [day, month, year] = dateString.split("/");

  // Créer une nouvelle date en utilisant le format ISO 8601 : "YYYY-MM-DDTHH:mm:ss.sssZ"
  const isoDateString = `${year}-${month}-${day}T00:00:00.000Z`;

  // Créer un nouvel objet Date avec la chaîne de caractères au format ISO 8601
  return new Date(isoDateString);
}
export function sortData(array, key, isReverse = false) {
  const sortedData = array?.sort((a, b) => {
    if (key === "estimatedFirstTransDate") {
      const dateA = convertToISODate(a[key]);
      const dateB = convertToISODate(b[key]);

      if (dateA.toLocaleDateString() === dateB.toLocaleDateString()) {
        if (a.certificationCode < b.certificationCode) return -1;
        if (a.certificationCode > b.certificationCode) return 1;
        return 0;
      }

      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
    } else if (key === "carbonFootPrint") {
      const x = a[key] !== null ? parseInt(a[key]) : 0;
      const y = b[key] !== null ? parseInt(b[key]) : 0;
      if (x === y) {
        if (a.certificationCode < b.certificationCode) return -1;
        if (a.certificationCode > b.certificationCode) return 1;
        return 0;
      }

      if (x < y) {
        return -1;
      }
      if (x > y || (x === 0 && y !== 0) || (y === 0 && x !== 0)) return 1;
    } else {
      if (a[key] === b[key]) {
        if (a.certificationCode < b.certificationCode) return -1;
        if (a.certificationCode > b.certificationCode) return 1;
        return 0;
      }
      if (a[key] < b[key] && a[key] !== null) return -1;
      if (
        a[key] > b[key] ||
        (a[key] === null && b[key] !== null) ||
        (b[key] === null && a[key] !== null)
      )
        return 1;
    }

    return 0;
  });

  return isReverse ? sortedData.reverse() : sortedData;
}

export const sortDataByStatus = (arrayList) => {
  const valueOrder = { 3: 0, 2: 1, 1: 2, 4: 3 };
  const sortedData = arrayList?.sort((a, b) => {
    const aValue = valueOrder[a.certificationStatus];
    const bValue = valueOrder[b.certificationStatus];

    if (aValue === bValue) {
      if (a.certificationCode < b.certificationCode) return -1;
      if (a.certificationCode > b.certificationCode) return 1;
      return 0;
    }

    return aValue - bValue;
  });

  return sortedData;
};

export const formatToMMDDYYYY = (inputDate) => {
  const date = new Date(inputDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month.toString().padStart(2, "0")}/${day
    .toString()
    .padStart(2, "0")}/${year}`;
};

export const standardList = [
  "American Carbon Registry",
  "Architecture for REDD+ Transactions",
  "Australian Emissions Reduction Fund",
  "Clean Development Mechanism",
  "Climate Action Reserve",
  "Gold Standard",
  "J-Credit Scheme",
  "UK Woodland Carbon Code",
  "Verified Carbon Standard (Verra)",
];

export const yearsList = () => {
  const years = [];
  for (let i = 2000; i <= new Date().getFullYear(); i++) {
    years.push(i);
  }
  return years;
};

const capitalizeText = (text) => {
  return text.replace(/\([^()]+\)/g, (match) => match.toLowerCase());
};

export const formatLabel = (label) => {
  const parts = label?.split(/(\([^()]+\))/);
  return parts?.map((part, index) =>
    part.startsWith("(") ? (
      <span key={index}>{part}</span>
    ) : (
      <span key={index} className="capitalize">
        {capitalizeText(part)}
      </span>
    )
  );
};

export function formatStringToTitle(string) {
  // If the string contains all uppercase letters or all lowercase letters, convert it to lowercase first
  if (string === string.toUpperCase() || string === string.toLowerCase()) {
    string = string.toLowerCase();
  }

  // Replace uppercase letters not at the beginning of the string, following two or more consecutive uppercase letters,
  // or following '(' with spaces before capitalizing
  string = string.replace(
    /(?<![A-Z])(?<![A-Z]{2,})(?<!\()(?<![A-Z] ?\()(?<![A-Z] ?[A-Z])(?=[A-Z])/g,
    " "
  );

  // Capitalize the first letter of the string and each word
  string = string.replace(/\b\w/g, (l) => l.toUpperCase());

  // Handle uppercase letters enclosed in parentheses
  string = string.replace(/\([^)]+\)/g, (match) => match.toUpperCase());

  return string;
}
